export default __webpack_public_path__ + "assets/computer404.bdec.svg";